import { faqs } from '@/mocks/home';

export default function FaqSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-3xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-4 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-3">
            常见问题
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            你可能想了解
          </h2>
          <p className="mt-2 text-sm text-foreground-600">关于平台使用的常见疑问解答</p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq) => (
            <div key={faq.id} className="bg-background-50 rounded-xl p-5 md:p-6">
              <h3 className="font-heading text-base font-semibold text-foreground-950 flex items-start gap-3">
                <span className="text-primary-500 flex-shrink-0 mt-0.5">Q</span>
                <span>{faq.question}</span>
              </h3>
              <p className="mt-3 text-sm text-foreground-700 leading-relaxed pl-7">
                {faq.answer}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}